export const commonFunctions = {
    orderStatus,
    paymentStatus
};

function orderStatus(orderStatus, siteConstants) {
    let status = '';
    if (orderStatus == "pending") { status = siteConstants.ORDER_PENDING_AT_SHOP; }
    else if (orderStatus == "preparing") { status = siteConstants.ORDER_IS_PREPARING_AT_SHOP; }
    else if (orderStatus == "prepared") { status = siteConstants.ORDER_PREAPRED_BY_SHOPKEEPER; }
    else if (orderStatus == "rejected_by_shopkeeper") { status = siteConstants.ORDER_REJECTED_BY_SHOP; }
    else if (orderStatus == "accepted_by_shopkeeper") { status = siteConstants.ORDER_ACCEPTED_BY_SHOPKEEPER; }
    else if (orderStatus == "assign_to_delivery_boy") { status = siteConstants.ORDER_ASSIGNED_TO_DELIVERY_BOY; }
    else if (orderStatus == "accepted_by_delivery_boy") { status = siteConstants.ORDER_ACCEPTED_BY_DELIVERY_BOY; }
    else if (orderStatus == "rejected_by_delivery_boy") { status = siteConstants.ORDER_REJECTED_BY_DELIVERY_BOY; }
    else if (orderStatus == "picked_up_by_delivery_boy") { status = siteConstants.ORDER_PICKED_BY_DELIVERY_BOY; }
    else if (orderStatus == "canceled_by_customer") { status = siteConstants.ORDER_CANCELED_BY_CUSTOMER; }
    else if (orderStatus == "rental_returning_request_by_user") { status = siteConstants.ORDER_RENTAL_REQUEST_BY_USER; }
    else if (orderStatus == "rental_returning_assign_to_delivery_boy") { status = siteConstants.ORDER_RENTAL_REQUEST_ASSIGNED_TO_DELIVERY_BOY; }
    else if (orderStatus == "rental_returning_accepted_by_delivery_boy") { status = siteConstants.ORDER_RENTAL_REQUEST_ACCEPTED_BY_DELIVERY_BOY; }
    else if (orderStatus == "rental_returning_rejected_by_delivery_boy") { status = siteConstants.ORDER_RENTAL_REQUEST_REJECTED_BY_DELIVERY_BOY; }
    else if (orderStatus == "rental_returning_collected_by_delivery_boy") { status = siteConstants.ORDER_RENTAL_RETURN_COLLECTED_BY_DELIVERY_BOY; }
    else if (orderStatus == "rental_returning_deposit_to_shopkeeper") { status = siteConstants.ORDER_RENTAL_RETURN_DEPOSITED_TO_SHOPKEEPER; }
    else if (orderStatus == "order_completed_by_shopkeeper") { status = siteConstants.ORDER_COMPLETE; }
    else if (orderStatus == "cancelation_accepted_by_shopkeeper") { status = siteConstants.ORDER_CANCELATION_ACCEPTED_BY_SHOPKEEPER; }
    else if (orderStatus == "delivered") { status = siteConstants.ORDER_DELIVERED_BY_DELIVERY_BOY; }
    else if (orderStatus == "order_rejected_by_customer_on_deilvery_time") { status = siteConstants.ORDER_REJECTED_BY_CUSTOMER_ON_DELIVERY_TIME; }
    
    else { }
    return status;
}


function paymentStatus(paymentStatus) {
    let status = '';
    if (paymentStatus == "pending") { status = 'Payment Pending'; }
    else if (paymentStatus == "complete" || paymentStatus == "completed") { status = 'Payment Paid'; }
    else if (paymentStatus == "collected_by_delivery_boy") { status = 'Payment Collected By Delivery Boy'; }
    else if (paymentStatus == "delivery_rejected_by_customer") { status = 'Payment Canceled - Delivery Rejected By Customer at the time of delivery'; }
    else { }
    return status;
}
